import React from "react";
import { useHistory } from "react-router-dom";
import { analytics } from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import Grid from "@material-ui/core/Grid";
import useStyles from "./style/style";

function CollectionProduct() {
  const { collectionProduct } = useData();
  const history = useHistory();
  const classes = useStyles();

  const toCollectionDetail = (index, nama) => {
    analytics.logEvent("collections_product", { col: nama });

    history.push(`/collections/${index}`);
  };

  return (
    <Grid
      container
      spacing={1}
      style={{ paddingTop: "8px", paddingBottom: "8px" }}
    >
      {collectionProduct?.map((item, index) => (
        <Grid item xs={6}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => toCollectionDetail(index, item.name)}
          >
            <img src={item.preview_image} className={classes.imageCollection} />
          </div>
        </Grid>
      ))}
    </Grid>
  );
}

export default CollectionProduct;
